import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MuniPlots2D from './MuniPlots2D';
import MuniPlots3D from './MuniPlots3D'
import CorpPlots2D from './CorpPlots2D';
import CorpPlots3D from './CorpPlots3D'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const ids = ["MPlot2D", "MPlot3D", "CPlot2D", "CPlot3D"]
const element_styler = {
  position: "relative",
  top: "50px",
  left: document.body.clientWidth / 8 + "px",
  backgroundColor: "#151720",
  color:"white",
  fontSize:"20px",
  zIndex:"10",
  borderColor:"white",
  borderWidth:"2px",
  borderRadius:"10px",
}
let prevId = "MPlot2D"
function changeModel(evt) {
  document.getElementById(prevId).style.display='none'
  document.getElementById(evt.target.value).style.display = 'block'
  prevId = evt.target.value
  
}
root.render(
  <React.StrictMode>
    <select
      onChange={(e) => changeModel(e)}
      style= {
        element_styler
      }
    >
      <option 
        value="MPlot2D"
      >
        Cr&Re Arb 2D</option>
      
      <option 
        value="MPlot3D"
      >
        Cr&Re Arb 3D</option>
      
      <option 
        value="CPlot2D"
      >
        Liquidity Arb 2D</option>
      
      <option 
        value="CPlot3D"
      >
        Liquidity Arb 3D</option>
    </select>
    <div
      id="MPlot2D"
      style={{
        display:'block'
      }}
    >
      <MuniPlots2D />
      
    </div>
    <div
      id="MPlot3D"
      style={{
        display:'none'
      }}
    >
      <MuniPlots3D />
      
    </div>
    <div
      id="CPlot2D"
      style={{
        display:'none'
      }}
    >
      <CorpPlots2D />
      
    </div>
    <div
      id="CPlot3D"
      style={{
        display:'none'
      }}
    >
      <CorpPlots3D />
      
    </div>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
